import client from "../client";

const getMe = () => client.get<any>(`/users/get/me`);

const getUsers = (props: any) => client.post<any>(`/users/get/salaries`, props);

const updateDisabledPushNotificationsByCurrentUser = () =>
  client.patch<any>(`/users/toggle-push-notifications`);

const changeLanguageByCurrentUser = (language: string) =>
  client.patch<any>(`/users/change-language/${language}`);

const usersApi = {
  getMe,
  getUsers,
  updateDisabledPushNotificationsByCurrentUser,
  changeLanguageByCurrentUser,
};
export default usersApi;
